import corporateCenterIndexPc from "./fragments/corporate-center-index-pc/zh-tw";
import corporateCenterPortal from "./fragments/corporate-center-portal/zh-tw";
import corporateCenterJoinM from "./fragments/corporate-center-join-m/zh-tw";
import corporateCenterJoinPc from "./fragments/corporate-center-join-pc/zh-tw";
import mentorJoinIndexPc from "./fragments/mentor-join-index-pc/zh-tw";
import mentorJoinJoinPc from "./fragments/mentor-join-join-pc/zh-tw";
import mentorJoinRecordingGuide from "./fragments/mentor-join-recording-guide/zh-tw";
import mHeader from "./fragments/m-header/zh-tw";
import index from "./fragments/index/zh-tw";
import common from "./fragments/common/zh-tw";
import serviceInstitutionPc from "./fragments/service-institution-pc/zh-tw";
import userPc from "./fragments/user-pc/zh-tw";
import square from "./fragments/square/zh-tw";
import aboutUs from "./fragments/aboutus/zh-tw";
import tests from "./fragments/tests/zh-tw";
import masterFortune from "./fragments/master-fortune/zh-tw";
import chat from "./fragments/chat/zh-tw";
import teacherDetailPc from "./fragments/teacher-detail-pc/zh-tw";
import creator from "./fragments/creator/zh-tw";
import tools from "./fragments/tools/zh-tw";

export default {
	index,
	common,
	square,
	corporateCenter: {
		indexPc: corporateCenterIndexPc,
		...corporateCenterPortal,
		joinM: corporateCenterJoinM,
		joinPc: corporateCenterJoinPc,
	},

	mentorJoin: {
		indexPc: mentorJoinIndexPc,
		joinPc: mentorJoinJoinPc,
		recordingGuide: mentorJoinRecordingGuide,
	},

	mHeader,
	serviceInstitution: {
		pc: serviceInstitutionPc,
	},
	user: {
		pc: userPc,
	},
	aboutUs,
	tests,
	masterFortune,
	chat,
	teacherDetail: {
		pc: teacherDetailPc,
	},
	creator,
	tools,
};
